// extracted by mini-css-extract-plugin
export default {"main":"f25b568b49 _22b872b0ee f418c3ab63 _3a1d1b3f69","title":"_67162cf0a0"};